import { render } from "./PackagePreparations.vue?vue&type=template&id=0c9af46e"
import script from "./PackagePreparations.vue?vue&type=script&lang=js"
export * from "./PackagePreparations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__